import { Component, OnInit, ViewChild, ElementRef, Inject } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar, MatDialog } from '@angular/material';
import { AuthStore } from 'src/app/stores/auth/auth.store';
import { ActivityStore } from 'src/app/stores/resources/activity.store';
import { DataService } from 'src/app/services/data.service';
import { IActivity, IVocabulary } from 'src/app/interfaces/resource';
import { DISPLAY_STATUS_OBJECT, STATUS_OBJECT } from 'src/app/dummy/status';
import { ConvertService, pushObjArray } from 'src/app/services/convert.service';
import { COLLECTION_NAME } from 'src/app/dummy/app';
import { Router } from '@angular/router';
import { AddSenteceStructureComponent } from '../add-sentece-structure/add-sentece-structure.component';

@Component({
  selector: 'app-add-sentece-structure-exercise',
  templateUrl: './add-sentece-structure-exercise.component.html',
  styleUrls: ['./add-sentece-structure-exercise.component.scss']
})
export class AddSenteceStructureExerciseComponent implements OnInit {
  @ViewChild('focusInput', {static:false}) inputEl: ElementRef;

  TITLE = "Create sentence structure"

  form: FormGroup;
  question: AbstractControl;

  processNew: boolean = false;
  processClose: boolean = false;
  error: any = null;
  isCreate: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<AddSenteceStructureExerciseComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private auth: AuthStore,
    public store: ActivityStore,
    private snackBar: MatSnackBar,
    private ds: DataService,
    private dialog: MatDialog,
    private route: Router,
  ) { }

  ngOnInit() {
    const { EXERCISE } = this.data;
    this.form = this.fb.group({
      question: [EXERCISE ? EXERCISE.word : null, Validators.compose([Validators.required])],
    })
    if (EXERCISE) {
      this.TITLE = "Edit sentence structure";
    }
  }


  delete(item: any) {
    this.store.options = this.store.options.filter(m => m.key !== item.key) || [];
  }

  addNewLine(item: any) {
    let dialogRef = this.dialog.open(AddSenteceStructureComponent, {
      data: {
        QUESTION: this.data.QUESTION || {},
        ANSWER: item || null,
      },
      panelClass: 'item-list-panel',
      width: '30vw',
      height: '100vh',
      disableClose: false,
      role: 'dialog',
    });
    dialogRef.updatePosition({ top: '0', right: '0', bottom: '0' });
    dialogRef.afterClosed().subscribe(result => {
    });
  }


  async onSave(f: any, isDraft: boolean, isNew: boolean) {
    const { FORM, SKILL, ACTIVITY_TYPE, MODULE_KEY, ITEM, ACTIVITY_TYPE_OBJECT, SKILL_NAME, EXERCISE } = this.data;
    this.processClose = isDraft ? false : true;
    this.processNew = isDraft;
    this.error = null;
    this.isCreate = true;
    if (this.form.valid) {
      this.form.disable();
      const { question } = f;
      const key = ITEM ? ITEM.key : this.ds.createId();
      const wordKey = EXERCISE ? EXERCISE.key : this.ds.createId();
      const { options } = this.store;
      const { name, instruction, defaultInstruction, grammar } = FORM;
      const { user, selectedCompanyKey } = this.auth;
      const questions = ITEM ? ITEM.questions : [];
      const registerStatus = STATUS_OBJECT.submitted;
      const wordData: IVocabulary = {
        word: `${question}`.trim(),
        key: wordKey,
        answers: options || [],
      };
      const WORDS_DATA = pushObjArray(questions || [], wordData)
      const activity: IActivity = {
        key: key,
        status: DISPLAY_STATUS_OBJECT.ACTIVE,
        isDelete: false,
        created_at: ITEM ? ITEM.created_at : new Date(),
        created_by: ITEM ? ITEM.created_by : user.uid,
        updated_at: new Date(),
        updated_by: user.uid,
        date_key: ITEM ? ITEM.date_key : ConvertService.dateKey(),
        page_key: ConvertService.pageKey(),
        keyword: null,
        organizationRef: this.ds.companyRef().doc(selectedCompanyKey).ref,
        organizationKey: selectedCompanyKey,
        created_byRef: ITEM ? ITEM.created_byRef : this.ds.userProfileRef().doc(user.uid).ref,
        updated_byRef: this.ds.userProfileRef().doc(user.uid).ref,
        register_status: registerStatus,
        //fields
        name: name || null,
        grammar: grammar || null,
        instruction: instruction || null,
        defaultInstruction: defaultInstruction || false,
        questions: WORDS_DATA,
        hasSubActivity: true,
        //module
        skillKey: SKILL,
        skillRef: this.ds.skillRef().doc(SKILL).ref,
        skillName: SKILL_NAME,
        activityTypeKey: ACTIVITY_TYPE,
        activityTypeRef: this.ds.activityTypeRef().doc(ACTIVITY_TYPE).ref,
        activityTypeName: ACTIVITY_TYPE_OBJECT.name,
        moduleKey: MODULE_KEY,
        moduleRef: this.ds.firestoreRef().collection(COLLECTION_NAME.MODULE).doc(MODULE_KEY).ref,
      }
      this.store.addItem(activity, this.data.MODULE, true, (success, res) => {
        this.data.ITEM = activity;
        this.snackBar.open("Sentence structure has been saved successful.", "Done", { duration: 1000 });
        if (!isNew) {
          this.route.navigate([`/modules/activity-type/${ACTIVITY_TYPE}/${SKILL}/${MODULE_KEY}/${activity.key}`])
          this.dialogRef.close('no')
          return;
        }
        this.form.reset();
        this.form.enable();
        this.form.patchValue({ isFill: false })
        this.processNew = false;
        this.processClose = false;
        this.store.options=[];
        this.isCreate = false;
        this.inputEl.nativeElement.focus()
        this.route.navigate([`/modules/activity-type/${ACTIVITY_TYPE}/${SKILL}/${MODULE_KEY}/${activity.key}`])
      })
    }
    else {
      this.processNew = false;
      this.processClose = false;
      this.isCreate = false;
    }
  }
}